<table mat-table [dataSource]="config.dataSource">
    <ng-container [matColumnDef]="keyTuple[0]" *ngFor="let keyTuple of config.dataSourceKeys">
        <th mat-header-cell *matHeaderCellDef>{{ keyTuple[1] }}</th>
        <td
            mat-cell

            *matCellDef="let row"

            (click)="onRowClicked(row)"
        >
            {{ row[keyTuple[0]] }}
        </td>
    </ng-container>

    <ng-container [matColumnDef]="moreColumnKey">
        <th mat-header-cell *matHeaderCellDef>More</th>
        <td mat-cell *matCellDef="let row; let i = index;">
            <a
                #menuTrigger="matMenuTrigger"

                href="javascript:void(0);"

                [matMenuTriggerFor]="menu"
                [matMenuTriggerData]="row"

                (click)="actionMenuTriggered(menuTrigger)"
            >
                <i class="fa fa-ellipsis-h fa-lg" #menuTriggerI></i>
            </a>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="getColumnKeys()"></tr>
    <tr mat-row *matRowDef="let row; columns: getColumnKeys();"></tr>

    <ng-container [matColumnDef]="notFoundColumnKey">
        <td mat-footer-cell *matFooterCellDef [colSpan]="getColumnKeys().length">No result found.</td>
    </ng-container>

    <tr
        mat-footer-row

        class="text-center"

        *matFooterRowDef="[notFoundColumnKey]"

        [ngClass]="{'d-none': config.dataSource.length !== 0}"></tr>
</table>

<mat-menu
    #menu="matMenu"

    xPosition="before"

    appClickOutside

    (clickOutside)="onActionMenuOutsideClick($event)"
>
    <button
        mat-menu-item

        *ngFor="let linkTuple of config.actionMenuLinks"

        (click)="onActionMenuLinkClicked(linkTuple[1])"
    >
        <span>{{ linkTuple[0] }}</span>
    </button>
</mat-menu>
